import React from "react";
import { Navbar, Container } from "react-bootstrap";
import ProfileCard from "./ProfileCard";
import "styles/Header.css";
import logo_white from "assets/images/logo_white.png";

const Header = ({ handleShowSidebar, showSidebar }) => {
  return (
    <Navbar expand="lg" className="app-navbar navbar-dark py-1">
      <Container fluid className="justify-content-start">
        <Navbar.Toggle
          aria-controls="offcanvasNavbar"
          aria-expanded={showSidebar}
          aria-label="Toggle navigation menu"
          onClick={handleShowSidebar}
          className="d-lg-none me-2"
        />
        <Navbar.Brand className="d-flex align-items-center">
          <img src={logo_white} alt="GFA Logo" height="30" width="auto" />
        </Navbar.Brand>
        <div className="d-none d-lg-flex ms-auto align-items-center">
          <ProfileCard light={true} />
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
